import axios from 'axios';

export type ConfigurationEntry = {
    propertyName: string;
    propertyValue: string;
}

export const listConfig = async (): Promise<ConfigurationEntry[]> => {
    const res = await axios.get<ConfigurationEntry[]>(`/config`);
    return res.data;
};

export const setConfig = async (name: string, value: string): Promise<void> => {
    await axios.put(`/config`, {propertyName: name, value});
};
